import { useCallback } from "react";
import { useFolderTreeCreatableMode } from "./useFolderTreeCreatableMode.js";
import { useFolderTree } from "../../contexts/folderTree.js";
import { clearCreatableDraftPlacement, computeCreatableDraftPlacement } from "../../util/applyCreatableDraftPlacement.js";
/**
 * Opens / dismisses creatable drafts via ImmutableContext (`creatableDraft` + `creatableParentId`).
 * Consumers supply `prepareCreatableDraft` and `onCreatablePersist` only.
 */ function useFolderTreeCreatableActions() {
    const { getCreatableSelectedId, getCreatableRootPlacementIds, onCreatableDismiss, prepareCreatableDraft, rootId, set } = useFolderTree();
    const { setCreatableModeActive } = useFolderTreeCreatableMode();
    const resolveRootPlacementIds = useCallback(()=>getCreatableRootPlacementIds?.() ?? [
            rootId ?? 0,
            "ALL"
        ], [
        getCreatableRootPlacementIds,
        rootId
    ]);
    const openCreatable = useCallback((draft, sessionType, selectedIdOverride)=>{
        const placement = computeCreatableDraftPlacement({
            selectedId: selectedIdOverride ?? getCreatableSelectedId?.(),
            rootPlacementIds: resolveRootPlacementIds(),
            draft
        });
        set({
            ...placement,
            creatableLastOpenType: sessionType
        });
        setCreatableModeActive(true);
    }, [
        getCreatableSelectedId,
        resolveRootPlacementIds,
        set,
        setCreatableModeActive
    ]);
    const openCreatableFromType = useCallback((type)=>{
        const draft = prepareCreatableDraft?.(type);
        if (!draft) {
            return;
        }
        openCreatable(draft, type);
    }, [
        openCreatable,
        prepareCreatableDraft
    ]);
    const dismissCreatable = useCallback(()=>{
        onCreatableDismiss?.();
        set(clearCreatableDraftPlacement());
        setCreatableModeActive(false);
    }, [
        onCreatableDismiss,
        set,
        setCreatableModeActive
    ]);
    return {
        openCreatable,
        openCreatableFromType,
        dismissCreatable
    };
}
export { useFolderTreeCreatableActions };
